module.exports = __webpack_public_path__ + "h5/img/dfk.67da4bbb.png";